module.exports = __webpack_public_path__ + "img/button2.523e55df.png";